import React from 'react';
import PropTypes from 'prop-types';
import mergeClassNames from 'merge-class-names';
import { getHours } from '@wojtekmaj/date-utils';

import { convert24to12 } from '../shared/dates';
import { isTime } from '../shared/propTypes';
import { getAmPmLabels } from '../shared/utils';

export default function AmPm({
  ariaLabel,
  className,
  disabled,
  itemRef,
  locale,
  maxTime,
  minTime,
  onChange,
  required,
  value
}) {
  const amDisabled = minTime && convert24to12(getHours(minTime))[1] === 'pm';
  const pmDisabled = maxTime && convert24to12(getHours(maxTime))[1] === 'am';

  const name = 'amPm';
  const [amLabel, pmLabel] = getAmPmLabels(locale);
  const arrowClassValueUpAdit = `date-time-picker-arrow__up__${name}`;
  const arrowClassValueDownAdit = `date-time-picker-arrow__down__${name}`;

  const alignArrows = (input) => {
    try {
      const widthString = getComputedStyle(input).width;
      const width = +widthString.slice(0, widthString.length - 2);
      const arrowUp = document.getElementsByClassName(arrowClassValueUpAdit)[0];
      const arrowDown = document.getElementsByClassName(arrowClassValueDownAdit)[0];
      const w = arrowUp.clientWidth;
      arrowUp.style.left = Math.round((width - w) / 2) + 'px';
      arrowDown.style.left = Math.round((width - w) / 2) + 'px';
    } catch(e) {}
  };

  const changeByArrows = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.value = value === 'pm' ? 'am' : 'pm';
    onChange(e)
  };

  return (
      <div className='date-time-picker__arrows-container'>
        {/*{hasLeadingZero && <span key="leadingZero" className={`${className}__leadingZero`}> 0 </span>}*/}
        {
          <span className={'date-time-picker__arrow date-time-picker-arrow__up ' + arrowClassValueUpAdit}
                                         onClick={changeByArrows}
          >{'>'}</span>
        }
    <select
      aria-label={ariaLabel}
      className={mergeClassNames(
        `${className}__input`,
        `${className}__${name}`,
      )}
      disabled={true}
      name={name}
      onChange={onChange}
      ref={(ref) => {
        if (itemRef) {
          itemRef(ref, name);
          alignArrows(ref);
        }
      }}
      required={required}
      value={value !== null ? value : ''}
    >
      {!value && (
        <option value="">
          --
        </option>
      )}
      <option disabled={amDisabled} value="am">
        {amLabel}
      </option>
      <option disabled={pmDisabled} value="pm">
        {pmLabel}
      </option>
    </select>
        {
          <span className={'date-time-picker__arrow date-time-picker-arrow__down ' + arrowClassValueDownAdit}
                onClick={changeByArrows}
          >{'<'}</span>
        }
      </div>
  );
}

AmPm.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  itemRef: PropTypes.func,
  locale: PropTypes.string,
  maxTime: isTime,
  minTime: isTime,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.oneOf(['am', 'pm']),
};
